import { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { YSButton } from "../../../uikit/YSButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RadioGroup from "@mui/material/RadioGroup";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {
  blackColor,
  BtnGroupStyle,
  DRxCheckboxStyle,
  DRxInputStyle,
  DRxSelectStyle,
  DRxTextareaStyle,
  NoteToggleStyle,
  warnColor,
  RxPadBox,
  LgCardStyle,
  BtnGroupWAStyle,
} from "../../../Theme";
import TimeIcon from "../../../images/icons/TimeIcon.svg";
import { DialogPopup } from "../../../components/DialogPopup";
import YSCheckBox from "../../../uikit/YSCheckBox";
import TimeList from "../../../components/TimeList";
import PharmacyDataList from "../../PharmacyDataList";
import DRxSelect from "../../../uikit/DRxSelect";
import DRxInput from "../../../uikit/DRxInput";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import DRxTextarea from "../../../uikit/DRxTextarea";
import SearchIcon from "../../../images/icons/SearchIcon.svg";
import { useSelector } from "react-redux";

const initialStateRxPad = {
  drugResourceLinkOptions: [],
  addToFavoriteDrugs: "",
  substitutionCode: null,
  sigDeliveryId: "",
  sigDeliveryOptions: null,
  sigDoseId: "",
  sigDoseOptions: null,
  sigDoseUnitsId: "",
  sigDoseUnitsOptions: null,
  sigFreqId: "",
  stepMedicationsList: null,
  sigFreqOptions: null,
  sigTimeMorning: "",
  controlledSubstance: null,
  sigTimeNoon: "",
  sigTimeEvening: "",
  sigTimeNight: "",
  sigTimeBedTime: "",
  sigTimeBeforeMeals: "",
  sigTimeAfterMeals: "",
  drugTypeOptionsDisableFlag: false,
  pharmacyEditDisableFlag: false,
  sigTimeBeforeBed: "",
  sigDrugNameRouteStrengthOptions: null,
  xdeaNumber: "",
  deaClassCode: "",
  stepMedicationDrugFalg: "",
  doctorNote: "",
  refillsDisableFlag: null,
  sigFreeText: "",
  prescriptionType: "",
  priorAuthorization: null,
  priorityIndicator: null,
  postDatedPrescription: null,
  postDatedPrescriptionDate: null,
  copay: "",
  coverage: "",
  drugType: "",
  hiddenDrugName: "",
  drugName: "",
  drugId: "",
  drugDescription: "",
  dosageForm: "",
  strength: "",
  strengthUnit: "",
  formularyStatus: "",
  sig: "",
  route: "",
  daysSupply: "",
  quantity: "",
  qtyQualifier: "",
  refills: "",
  instructions: "",
  doctorInstructions: "",
  type: null,
  patientId: "",
  doctorId: "",
  ePAFlag: "",
  epcsQueued: false,
  qtyQualifiersOptions: [],
  typesOptions: null,
  wcxfrIndicatorOptions: null,
  substitutionCodeOptions: null,
  drugsOptions: null,
  rxhubPBMUniqueIdOptions: [],
  userId: "",
  practiceId: "",
  pharmacyBenifits: "",
  benifitFlag: "",
  rxNumber: 1,
  medicationHistoryId: null,
  savedPrescriptionId: null,
  favoriteDrugId: null,
  practiceFavoriteDrugId: null,
  dispensibleDrugId: 0,
  rxOtcCode: null,
  formularyStatusCode: "",
  diagnosisIcd: null,
  diagnosisIcdOptions: null,
  pharacyCode: null,
  rxhubPBMUniqueId: "",
  initQtyQualifierListFlag: null,
  packSizeUnitCode: "",
  packDescCode: "",
  ndc: "",
  therapAltDrugsFlag: "",
  narcoticDrugFlag: false,
  allAlternativesList: null,
  drugResourceLink: [],
  payerAltdrugfalg: "",
  rtfAlternativeDrugsInfo: null,
  drugResourceLinks: "",
  healthPlanId: "",
  healthPlanGroupId: "",
  pbmParticipantId: "",
  rxDate: null,
  dailyMaxDose: "",
  drugInformation: "",
  pharmacyName: "",
  pharmacyFaxNumber: "",
  pharmacyCode: "",
  prescriptionCoverageMap: "",
};

export default function FreeTextForm(props: any) {
  const { panel, tabListLength } = props;
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state?.GlobalDropdownSlice?.DropdownLists };
  }); //redux data
  const pharmacyHisDropDown = useSelector((state: any) => {
    return { ...state?.PharmacyDropDownSlice };
  }); //redux data
  const [data, setData] = useState<any>(initialStateRxPad);
  const [formErrors, setFormErrors] = useState<{} | null>(null);

  const getLabels = (formProps: any) => {
    const { values } = formProps;
    let timelabels = "";
    if (values.sigTimeMorning === "ON") timelabels = timelabels + " at morning";
    if (values.sigTimeNight === "ON") timelabels = timelabels + " at night";
    if (values.sigTimeAfterMeals === "ON")
      timelabels = timelabels + " at after meals";
    if (values.sigTimeBedTime === "ON") timelabels = timelabels + " at bedtime";
    if (values.sigTimeNoon === "ON") timelabels = timelabels + " at noon";
    if (values.sigTimeBeforeBed === "ON")
      timelabels = timelabels + " at before bed";
    if (values.sigTimeBeforeMeals === "ON")
      timelabels = timelabels + " at before meals";
    if (values.sigTimeEvening === "ON") timelabels = timelabels + " at evening";
    let currentDelivery = AllDropdwonsState?.sigDeliveryOptions?.find(
      (each: any) => each?.qualifierValue == values.sigDeliveryId
    );
    let currentDose = AllDropdwonsState?.sigDoseOptions?.find(
      (each: any) => each?.name == values.sigDoseId
    );
    let currentUnits = AllDropdwonsState?.sigDoseUnitsOptions?.find(
      (each: any) => each?.qualifierValue == values.sigDoseUnitsId
    );
    let currentFreq = AllDropdwonsState?.sigFreqOptions?.find(
      (each: any) => each?.qualifierValue == values.sigFreqId
    );

    return `${currentDelivery?.name ?? ""} ${currentDose?.name ?? ""} ${
      currentUnits?.name ?? ""
    } ${currentFreq?.name ?? ""} ${timelabels ?? ""}`;
  };

  const setFelidErrors = () => {
    try {
      const errors: any =
        sessionStorage.getItem("freeTextRxTabsErrors") != "undefined" ||
        sessionStorage.getItem("freeTextRxTabsErrors") !== null
          ? JSON.parse(sessionStorage.getItem("freeTextRxTabsErrors")!)
          : null;
      const currentTab = JSON.parse(sessionStorage.getItem("TabValue")!);
      if (errors != null && errors?.length > 0) {
        const error = errors.filter(
          (error: any) => error.rxNumber?.toString() == currentTab
        );
        var rxErrors: any = {};
        error[0]?.errors.map((e: any) => {
          rxErrors[e.field] = e.errorMessage;
        });
        setFormErrors(rxErrors ?? null);
      }
    } catch (err) {}
  };
  useEffect(() => {
    setFelidErrors();
  }, [
    props.newPrescription,
    props.saveAndContinue,
    props.submitAllForms,
    props.resetRxForm,
  ]);
  useEffect(() => {
    setData(panel);
  }, [props.resetRxForm]);

  const [showPatientBenefits, setShowPatientBenefits] = useState(false);
  const [note, setNote] = useState("NotetoPharmacist");
  const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNote((event.target as HTMLInputElement).value);
  };

  const parentPharmacyCallBack = (event: any) => {
    if (event.target.value) {
      setShowPatientBenefits(!showPatientBenefits);
    }
  };

  const [free, SetFree] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleShowPopupClick = () => {
    setShowPopup(true);
  };
  const handleHidePopupClick = () => {
    setShowPopup(false);
  };

  const [showPopupP, setShowPopupP] = useState(false);
  const handleShowPopupClickP = () => {
    setShowPopupP(true);
  };
  const handleHidePopupClickP = () => {
    setShowPopupP(false);
  };
  const [EnsurePopUp, setEnsurePopUp] = useState(false);
  const handleShowEnsurePopupClick = () => {
    setEnsurePopUp(true);
  };
  const handleHideEnsurePopupClick = () => {
    setEnsurePopUp(false);
  };
  const [populateId, setPharmacyPopulateId] = useState<any>([]);

  useEffect(() => {
    if (populateId[0]) {
      setData(populateId[0]);
      const currentTabs =
        sessionStorage.getItem("freeTextRxTabs") != "undefined" ||
        sessionStorage.getItem("freeTextRxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
          : null;
      const updatedForm = currentTabs?.map((form: any) => {
        if (form.rxNumber === populateId[0]?.rxNumber) {
          return (form = populateId[0]);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("freeTextRxTabs", JSON.stringify(updatedForm));
      props.setTabList(updatedForm);
    }
  }, [populateId]);

  return (
    <>
      {pharmacyHisDropDown?.isLoading ? (
        <Box
          style={{
            width: "100%",
            height: 200,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            color={"primary"}
            component="div"
            fontWeight={500}
          >
            Please wait while we fetch the pharmacy!
          </Typography>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Formik
          initialValues={data}
          initialErrors={{ ...formErrors }}
          onSubmit={(values) => {
            setData(values);
            props.submitAllForms(values);
          }}
          enableReinitialize
        >
          {(formProps) => {
            return (
              <Form onSubmit={formProps.handleSubmit}>
                <Grid
                  container
                  xs={12}
                  alignItems="stretch"
                  justifyContent="stretch"
                  spacing={0}
                >
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rxpad2">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} md={12}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Drug Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxInputStyle>
                              <DRxInput
                                id="drugname"
                                name="drugName"
                                type="text"
                                className="input"
                                disabled={false}
                                onChange={formProps.handleChange}
                                value={formProps.values.drugName}
                                placeholder={"Enter Drug Name"}
                              />{" "}
                            </DRxInputStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} sm={8} md={6}>
                          <RxPadBox className="mt5">
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              htmlFor="dtype"
                              fontWeight={400}
                              style={{
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Drug type
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                id="dtype"
                                data={
                                  AllDropdwonsState?.freeTextDrugsTypesOptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                                name="drugType"
                                className=""
                                // disabled={
                                //   formProps.values.drugTypeOptionsDisableFlag
                                // }
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} sm={8} md={6}>
                          <RxPadBox className="mt5">
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              htmlFor="dtype"
                              fontWeight={400}
                              style={{
                                whiteSpace: "nowrap",
                                marginTop: 4,
                              }}
                              className="mdmw"
                            >
                              Rx/OTC
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                name="rxOtcCode"
                                id="dtype"
                                data={[
                                  { label: "Select", value: "0" },
                                  {
                                    label: "Prescription Required",
                                    value: "Prescription Required",
                                  },
                                  {
                                    label: "Over the Counter",
                                    value: "Over the Counter",
                                  },
                                ]}
                                errorMessage={formProps.errors?.rxOtcCode}
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <DRxCheckboxStyle className="addToFavoriteDrugs">
                            <YSCheckBox
                              name="addToFavoriteDrugs"
                              label={"Add to favorite drug"}
                            />
                          </DRxCheckboxStyle>
                        </Grid>
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rft rxpad3">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        {(free || formProps.values.sig !== "") &&
                        (!formProps.values.sigFreqId ||
                          !formProps.values.sigDeliveryId ||
                          !formProps.values.sigDoseId ||
                          !formProps.values.sigDoseUnitsId) ? (
                          <Grid item xs={12} md={12}>
                            <RxPadBox>
                              <Typography
                                component="label"
                                color={blackColor}
                                variant="body2"
                                fontWeight={400}
                                style={{
                                  marginTop: 7,
                                  whiteSpace: "nowrap",
                                }}
                                className="mdmw"
                              >
                                SIG
                                <Typography
                                  component="span"
                                  color={warnColor}
                                  variant="body2"
                                >
                                  *
                                </Typography>
                              </Typography>

                              <DRxTextareaStyle className="sig">
                                <DRxTextarea
                                  type="textarea"
                                  name="sig"
                                  id={"sig"}
                                />
                                <Typography
                                  component="label"
                                  color={"primary"}
                                  variant="body2"
                                >
                                  Please do not use latin abbreviations like
                                  BID, QID etc., when writing free text SIG.
                                </Typography>
                              </DRxTextareaStyle>
                            </RxPadBox>
                          </Grid>
                        ) : (
                          <>
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  color={blackColor}
                                  variant="body2"
                                  fontWeight={400}
                                  className="mdmw"
                                >
                                  Route of Administration
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    id="delivery"
                                    name="sigDeliveryId"
                                    label="Delivery"
                                    options={
                                      AllDropdwonsState?.sigDeliveryOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.qualifierValue,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(options: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigDeliveryId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigDeliveryId}
                                    onBlur={formProps.handleBlur}
                                    errorMessage={
                                      formProps.errors?.sigDeliveryId
                                    }
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>{" "}
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="xsmw"
                                >
                                  Dose
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    name="sigDoseId"
                                    id="dose"
                                    options={
                                      AllDropdwonsState?.sigDoseOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.name,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(option: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigDoseId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigDoseId}
                                    errorMessage={formProps.errors?.sigDoseId}
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  fontWeight={400}
                                  color={blackColor}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Units
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    name="sigDoseUnitsId"
                                    id="units"
                                    options={
                                      AllDropdwonsState?.sigDoseUnitsOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.qualifierValue,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(options: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigDoseUnitsId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigDoseUnitsId}
                                    errorMessage={
                                      formProps.errors?.sigDoseUnitsId
                                    }
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="xsmw"
                                >
                                  Freq
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    name="sigFreqId"
                                    id="freq"
                                    options={
                                      AllDropdwonsState?.sigFreqOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.qualifierValue,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(option: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigFreqId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigFreqId}
                                    errorMessage={formProps.errors?.sigFreqId}
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  color={blackColor}
                                  variant="body2"
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  SIG
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxInputStyle className="icon">
                                  <DRxInput
                                    id="sig"
                                    name="sig"
                                    type="text"
                                    className="input"
                                    disabled={false}
                                    inputProps={{ readOnly: true }}
                                    value={getLabels(formProps)}
                                    errorMessage={formProps.errors?.sig}
                                  />{" "}
                                  <DialogPopup
                                    windowsize={"sm"}
                                    icon={TimeIcon}
                                    title={"Time"}
                                    show={showPopup}
                                    handleShowPopupClick={handleShowPopupClick}
                                    handleHidePopupClick={handleHidePopupClick}
                                  >
                                    <TimeList
                                      showPopup
                                      setShowPopup
                                      handleShowPopupClick={
                                        handleShowPopupClick
                                      }
                                      handleHidePopupClick={
                                        handleHidePopupClick
                                      }
                                      formProps={formProps}
                                    />
                                  </DialogPopup>
                                </DRxInputStyle>
                              </RxPadBox>
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12} md={12}>
                          <RxPadBox>
                            {" "}
                            <Typography
                              component="label"
                              variant="body2"
                              className="mdmw"
                            ></Typography>
                            <DRxCheckboxStyle
                              style={{ left: -5, position: "relative" }}
                            >
                              <Typography
                                className="usefreetext"
                                variant="body2"
                                component={"label"}
                              >
                                <Checkbox
                                  name={"freeText1"}
                                  checked={
                                    (free || formProps.values.sig !== "") &&
                                    (!formProps.values.sigFreqId ||
                                      !formProps.values.sigDeliveryId ||
                                      !formProps.values.sigDoseId ||
                                      !formProps.values.sigDoseUnitsId)
                                  }
                                  onChange={(e: any) => {
                                    SetFree(!free);

                                    if (e.target.checked) {
                                      formProps.setFieldValue("sig", "");
                                      formProps.setFieldValue(
                                        "sigDeliveryId",
                                        ""
                                      );

                                      formProps.setFieldValue("sigDoseId", "");
                                      formProps.setFieldValue(
                                        "sigDoseUnitsId",
                                        ""
                                      );
                                      formProps.setFieldValue("sigFreqId", "");
                                      formProps.setFieldValue(
                                        "sigTimeMorning",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeNoon",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeEvening",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeNight",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeBedTime",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeBeforeMeals",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeAfterMeals",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeBeforeBed",
                                        ""
                                      );
                                    } else {
                                      formProps.setFieldValue("sig", "");
                                    }
                                  }}
                                />
                                Use free text
                              </Typography>
                            </DRxCheckboxStyle>
                          </RxPadBox>
                        </Grid>{" "}
                      </Grid>
                    </LgCardStyle>
                  </Grid>{" "}
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rxpad4">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} sm={8}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Qualifier
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxSelectStyle className="qualifier">
                              <DRxSelect2
                                name="packSizeUnitCode"
                                id="packSizeUnitCode"
                                options={
                                  data?.qtyQualifiersOptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                                onChange={(e: any, opt: any) => {
                                  formProps.setFieldValue(
                                    "packSizeUnitCode",
                                    opt.props.value
                                  );
                                  formProps.setFieldValue(
                                    "qtyQualifier",
                                    opt.props.children
                                  );
                                }}
                                value={formProps.values.packSizeUnitCode}
                                errorMessage={formProps.errors?.qtyQualifier}
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              color={blackColor}
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              Quantity
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxInputStyle className="w-auto quantity">
                              <DRxInput
                                id="quantity"
                                name="quantity"
                                type="text"
                                className="input "
                                disabled={false}
                              />
                            </DRxInputStyle>
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} sm={8}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={400}
                              color={blackColor}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Substitutions
                            </Typography>
                            <DRxSelectStyle className="substitutions">
                              <DRxSelect
                                name="substitutionCode"
                                id="substitute"
                                data={
                                  AllDropdwonsState?.substitutionCodeOptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} sm={4}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              Refill
                            </Typography>
                            <DRxInputStyle className="w-auto refill">
                              <DRxInput
                                id="refill"
                                name="refills"
                                type="text"
                                className="input "
                                disabled={
                                  formProps?.values?.refillsDisableFlag
                                    ? true
                                    : false
                                }
                              />
                            </DRxInputStyle>
                          </RxPadBox>
                        </Grid>
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rft rxpad5">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={400}
                              color={blackColor}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              WC/XFR
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                name="wcxfrIndicator"
                                id="wcxfr"
                                data={
                                  AllDropdwonsState?.wcxfroptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                              />{" "}
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              color={blackColor}
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              Type
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                name="type"
                                id="type"
                                data={
                                  AllDropdwonsState?.type ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>

                        {localStorage.getItem("themeSelection") ===
                          "imasys" && (
                          <Grid item xs={12} md={6}>
                            <RxPadBox>
                              <Typography
                                component="label"
                                variant="body2"
                                color={blackColor}
                                fontWeight={400}
                                style={{
                                  marginTop: 7,
                                  whiteSpace: "nowrap",
                                }}
                                className="mdmw"
                              >
                                Days Supply
                              </Typography>
                              <DRxInputStyle className="w-auto">
                                <DRxInput
                                  id="daysSupply"
                                  name="daysSupply"
                                  type="text"
                                  className="input"
                                  // disabled={
                                  //   UserServiceState?.disableDaysSupplyField &&
                                  //   formProps.values.rxhubPBMUniqueId ===
                                  //     "SELECT_BENEFIT_SOURCE"
                                  //     ? true
                                  //     : false
                                  // }
                                  value={
                                    // UserServiceState?.disableDaysSupplyField &&
                                    // formProps.values.rxhubPBMUniqueId ===
                                    //   "SELECT_BENEFIT_SOURCE"
                                    //   ? "N/A"
                                    //   :
                                    formProps.values.daysSupply
                                  }
                                />
                              </DRxInputStyle>
                            </RxPadBox>{" "}
                          </Grid>
                        )}
                      </Grid>
                    </LgCardStyle>
                  </Grid>{" "}
                  {formProps.values.diagnosisIcdOptions?.length > 0 && (
                    <Grid item xs={12} lg={12}>
                      <LgCardStyle className="rxpad6">
                        <Grid
                          container
                          item
                          xs={12}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                          columnSpacing={2}
                          rowSpacing={1}
                        >
                          {data?.diagnosisIcdOptions?.length > 0 && (
                            <Grid item xs={12} md={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Diagnosis
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect
                                    name="diagnosisIcd"
                                    id="diagnosis"
                                    data={
                                      data?.diagnosisIcdOptions ?? [
                                        { label: "", value: "" },
                                      ]
                                    }
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                          )}
                        </Grid>
                      </LgCardStyle>
                    </Grid>
                  )}
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rxpad8">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} md={12}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Pharmacy
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <DRxSelectStyle className="icon">
                              <DRxSelect
                                name="pharmacyCode"
                                id="pharmacyCode"
                                data={
                                  pharmacyHisDropDown?.PharmacyDropDownData?.map(
                                    (item: any) => ({
                                      value: item?.pharmacyCode,
                                      label: item?.nameConcatenatedWithAddress,
                                      optionColor: !item?.ssEnableFlag
                                        ? "yellow"
                                        : "",
                                    })
                                  ) ?? [
                                    {
                                      value: "",
                                      label: "",
                                    },
                                  ]
                                }
                                parentCallBack={parentPharmacyCallBack}
                                disabled={
                                  formProps?.values?.pharmacyEditDisableFlag
                                }
                                errorMessage={formProps.errors?.pharmacyCode}
                              />
                              <IconButton onClick={handleShowPopupClickP}>
                                <img
                                  src={SearchIcon}
                                  alt="SearchIcon"
                                  loading="lazy"
                                />
                              </IconButton>
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>{" "}
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rft rxpad9">
                      <NoteToggleStyle>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={note}
                          onChange={handleNoteChange}
                        >
                          <FormControlLabel
                            value="NotetoPharmacist"
                            control={<Radio />}
                            label="Note to Pharmacist"
                          />
                          <FormControlLabel
                            value="DoctorsNotes"
                            control={<Radio />}
                            label="Doctors Notes"
                          />
                        </RadioGroup>
                      </NoteToggleStyle>
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        {note === "NotetoPharmacist" ? (
                          <>
                            <Grid item xs={12} md={12}>
                              <RxPadBox>
                                <DRxTextareaStyle className="h44">
                                  <DRxTextarea
                                    type="textarea"
                                    label={"harmacy Note"}
                                    name="instructions"
                                    id={"pharmacynote"}
                                    placeholder={"Enter Pharmacy Note here"}
                                  />
                                  <Typography variant="body2" color="primary">
                                    (Please DO NOT include SIG information in
                                    'Note to Pharmacist')
                                  </Typography>
                                </DRxTextareaStyle>
                              </RxPadBox>
                            </Grid>{" "}
                          </>
                        ) : (
                          <>
                            <Grid item xs={12} md={12}>
                              <RxPadBox>
                                <DRxTextareaStyle className="h44">
                                  <DRxTextarea
                                    type="textarea"
                                    label={"Doctor Note"}
                                    name="doctorNote"
                                    id={"doctornote"}
                                    placeholder={"Enter Doctor Notes here"}
                                  />
                                  <Typography variant="body2" color="primary">
                                    (Doctor Note is internal purpose. Will not
                                    be shown to pharamcy)
                                  </Typography>
                                </DRxTextareaStyle>
                              </RxPadBox>
                            </Grid>{" "}
                          </>
                        )}
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12}>
                    <BtnGroupStyle className="right rxpad11">
                      <YSButton
                        size="large"
                        className=""
                        color="secondary"
                        dataTestId="submitBtn"
                        variant="outlined"
                        disabled={false}
                        type="reset"
                        children={"Reset"}
                        onClick={(e) => {
                          formProps.setFieldValue("pharmacyCode", null);
                          props.resetRxForm(formProps.values);
                        }}
                      />
                      {tabListLength === formProps.values.rxNumber ? (
                        <YSButton
                          className=""
                          children={"Add New"}
                          size={"large"}
                          type="button"
                          disabled={
                            false
                            // Message && true
                            // !UserServiceState?.allowedToPrint ||
                            // !UserServiceState?.allowedToPrintControlledSubstances
                            //   ? true
                            //   : false
                          }
                          color="primary"
                          variant="outlined"
                          startIcon={<AddCircleOutlineOutlinedIcon />}
                          onClick={(e) => {
                            // setFormState(true);
                            //props?.addNewTab(formProps?.values);
                            props.newPrescription(
                              formProps.values,
                              formProps.isValid
                            );
                          }}
                        />
                      ) : (
                        <YSButton
                          className=""
                          onClick={() => {
                            // props.submitAllForms(formProps?.values);
                            props.saveAndContinue(
                              formProps.values,
                              formProps.isValid
                            );
                          }}
                          disabled={
                            // Message && true
                            false
                            // !UserServiceState?.allowedToPrint ||
                            // !UserServiceState?.allowedToPrintControlledSubstances
                            //   ? true
                            //   : false
                          }
                          type="button"
                          variant="contained"
                          color="primary"
                          children={"Save & Continue"}
                          size="large"
                        />
                      )}
                      {/* {tabListLength === formProps.values.rxNumber && ( */}
                      <YSButton
                        className=""
                        onClick={handleShowEnsurePopupClick}
                        type="button"
                        disabled={
                          // Message && true
                          false
                          // !UserServiceState?.allowedToPrint ||
                          // !UserServiceState?.allowedToPrintControlledSubstances
                          //   ? true
                          //   : false
                        }
                        variant="contained"
                        color="primary"
                        children={
                          props?.submitLoad ? (
                            <CircularProgress size={28} color={"inherit"} />
                          ) : (
                            "Confirm Prescription(s)"
                          )
                        }
                        size="large"
                      />
                      {/* )} */}
                    </BtnGroupStyle>
                  </Grid>{" "}
                  <Grid item xs={12}>
                    <Typography variant="body1" color="error" marginTop={1}>
                      The medications prescribed here will not be used in
                      interactions checking. Formulary information will not be
                      available for these medications. It is the user's
                      responsibility to follow the laws if the medications
                      prescribed here come under the controlled substance
                      classification.
                    </Typography>
                  </Grid>
                </Grid>
                <DialogPopup
                  windowsize={"md"}
                  title={"Search Pharmacies"}
                  show={showPopupP}
                  handleShowPopupClick={handleShowPopupClickP}
                  handleHidePopupClick={handleHidePopupClickP}
                >
                  <PharmacyDataList
                    formData={formProps.values}
                    setPharmacyPopulateId={setPharmacyPopulateId}
                    handleHidePopupClick={handleHidePopupClickP}
                  />
                </DialogPopup>
                <DialogPopup
                  windowsize={"sm"}
                  title={"Ensure"}
                  show={EnsurePopUp}
                  handleShowPopupClick={handleShowEnsurePopupClick}
                  handleHidePopupClick={handleHideEnsurePopupClick}
                >
                  <Typography color="error" variant="h6">
                    Please ensure that the drug(s) selected is not a schedule
                    drug
                  </Typography>
                  <Grid item xs={12}>
                    <BtnGroupWAStyle>
                      <YSButton
                        className=""
                        children={"Ok"}
                        type="button"
                        dataTestId="submitBtn"
                        color="primary"
                        variant="contained"
                        size="large"
                        onClick={() => {
                          handleHideEnsurePopupClick();
                          formProps.handleSubmit();
                        }}
                      />
                      <YSButton
                        size="large"
                        className=""
                        color="secondary"
                        disabled={false}
                        type="button"
                        children={"Cancel"}
                        variant="outlined"
                        onClick={handleHideEnsurePopupClick}
                      />
                    </BtnGroupWAStyle>
                  </Grid>
                </DialogPopup>
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
}
